export const SET_ORDER_DETAIL = "SET_ORDER_DETAIL";
export const GET_FLEET_ORDER_DETAIL = "GET_FLEET_ORDER_DETAIL";
export const SET_FLEET_ORDER_DETAIL = "SET_FLEET_ORDER_DETAIL";
export const SET_POOL_GRID_DATA = "SET_POOL_GRID_DATA";
export const GET_POOL_GRID_DATA = "GET_POOL_GRID_DATA";
export const GET_PURCHASE_TYPE_DROPDOWN = "GET_PURCHASE_TYPE_DROPDOWN";
export const SET_PURCHASE_TYPE_DROPDOWN = "SET_PURCHASE_TYPE_DROPDOWN";
export const SET_REGISTERED_DROPDOWN = "SET_REGISTERED_DROPDOWN";
export const GET_REGISTERED_DROPDOWN = "GET_REGISTERED_DROPDOWN";
export const GET_ORDER_TYPE_DROPDOWN = "GET_ORDER_TYPE_DROPDOWN";
export const SET_ORDER_TYPE_DROPDOWN = "SET_ORDER_TYPE_DROPDOWN";
export const GET_CLIENT_CODE_DROPDOWN = "GET_CLIENT_CODE_DROPDOWN";
export const SET_CLIENT_CODE_DROPDOWN = "SET_CLIENT_CODE_DROPDOWN";
export const GET_REASON_CODE_DROPDOWN = "GET_REASON_CODE_DROPDOWN";
export const SET_REASON_CODE_DROPDOWN = "SET_REASON_CODE_DROPDOWN";
export const SET_CAPEX_DROPDOWN = "SET_CAPEX_DROPDOWN";
export const GET_CAPEX_DROPDOWN = "GET_CAPEX_DROPDOWN";
export const SET_ASSIGNTO_DROPDOWN = "SET_ASSIGNTO_DROPDOWN";
export const GET_ASSIGNTO_DROPDOWN = "GET_ASSIGNTO_DROPDOWN";
export const SET_VENDOR_DETAILS = "SET_VENDOR_DETAILS";
export const GET_VENDOR_DETAILS = "GET_VENDOR_DETAILS_FOR_PURCHASE_ORDER";
export const SET_PURACHSE_ORDER_STEPPER_DATA =
  "SET_PURACHSE_ORDER_STEPPER_DATA";
export const GET_PURACHSE_ORDER_STEPPER_DATA =
  "GET_PURACHSE_ORDER_STEPPER_DATA";
export const SET_ERROR = "SET_ERROR";
export const SET_PURACHSE_ORDER_STEPPER_INFO =
  "SET_PURACHSE_ORDER_STEPPER_INFO";
export const SET_CHANGE_LOGS = "SET_CHANGE_LOGS";
export const GET_CHANGE_LOGS = "GET_CHANGE_LOGS";
export const UPDATE_FLEET_STATUS_ORDER = "UPDATE_FLEET_STATUS_ORDER";
export const UPDATE_REASON_CODE = "UPDATE_REASON_CODE"

// Note: prefix with `PO_` to avoid collisions with CatalogManagement actions
export const GET_PO_EQ_CLASS_CODE_DROPDOWN = "GET_PO_EQ_CLASS_CODE_DROPDOWN";
export const SET_PO_EQ_CLASS_CODE_DROPDOWN = "SET_PO_EQ_CLASS_CODE_DROPDOWN";
